// extracted by mini-css-extract-plugin
export var logo = "headerLogoAndTel-module--logo--47c74";
export var phone = "headerLogoAndTel-module--phone--41998";
export var phoneBordered = "headerLogoAndTel-module--phone-bordered--d456f";
export var topLogo = "headerLogoAndTel-module--top-logo--dc1a4";